import { getByIdErrors, getElementTimestampErrors } from './helpers.js';
import { getKeyValidationErrors } from './validation.js';

const requiredOrderKeys = {
  bookings: getByIdErrors(getElementTimestampErrors, 1),
  createdBy: true,
  creationTimestamp: true,
  id: true,
  officeID: true,
  prescriberID: true,
  status: true
};
/**
 * Determine whether an object of type Partial<Order> meets
 * all requirements to be non-partial
 */

const isOrderValid = order => !getKeyValidationErrors(order, requiredOrderKeys);

class OrderCleaner {
  constructor(order) {
    this._order = order;
  }

  get order() {
    return this._order;
  }

}
/**
 * No Order cleaners exist at this time, but leaving to enable adding
 * cleaners.
 */


const cleanUpOrder = order => new OrderCleaner(order).order;
/**
 * Evaluate and clean an object of type Partial<Order>
 * to resolve a non-partial type
 */

const getValidatedOrder = order => {
  const cleanedOrder = cleanUpOrder(order);

  if (!isOrderValid(cleanedOrder)) {
    throw Error(`Order does not pass validation:
      ${getKeyValidationErrors(cleanedOrder, requiredOrderKeys)}`);
  }

  return cleanedOrder;
};

export { cleanUpOrder, getValidatedOrder, isOrderValid };
